import { createContext } from 'react';

const WithinFilterContext = /*#__PURE__*/createContext(false);

export { WithinFilterContext };
